import { useQueryClient } from '@tanstack/react-query';
import { isNumber } from 'lodash';
import { useCallback } from 'react';
import { AuditDetailsModel } from 'src/domain/models/AuditDetailsModel';
import { useAcquireIdToken } from 'src/hooks/auth/useAcquireIdToken';
import { useDevTools } from 'src/hooks/devtools/useDevTools';
import { AuditLogEnum } from 'src/infrastructure/rest-api/api-types';
import { apiCall } from 'src/infrastructure/rest-api/useApi';

export const useAuditLogDetailsApiQuery = () => {
    const queryClient = useQueryClient();
    const { isImpersonating, impersonateEmail, impersonateRoles } = useDevTools();
    const acquireIdToken = useAcquireIdToken();

    const fetch = useCallback(
        (entityId: number | string | null | undefined, module: AuditLogEnum | null) => {
            if (!isNumber(entityId) || Number.isNaN(entityId) || !module) {
                throw new Error('Invalid parameters for audit log details query');
            }
            return queryClient.fetchQuery<AuditDetailsModel[]>({
                queryKey: ['audit-log-details', entityId, module],
                gcTime: 0,
                staleTime: 0,
                queryFn: () => {
                    return apiCall<AuditDetailsModel[]>({
                        method: 'get',
                        acquireToken: acquireIdToken,
                        url: `/api/auditlogs/modules/${module}/${entityId}`,
                        impersonate: isImpersonating ? { email: impersonateEmail, roles: impersonateRoles } : undefined,
                    }).then((data) => data.toReversed());
                },
            });
        },
        [queryClient, acquireIdToken, isImpersonating, impersonateEmail, impersonateRoles]
    );

    return fetch;
};
